import { useState, useEffect } from 'react';
import api from '../api/axios';
import {PRIMARY_COLOR, SECONDARY_COLOR} from "../contants/Colors";

/**
 * Fetches branding for a given tenantId and returns it.
 * Falls back to default values if no branding set.
 */
export const useBranding = (tenantId) => {
  const [branding, setBranding] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!tenantId) { setLoading(false); return; }
    api.get(`/branding/public/${tenantId}`)
      .then(r => setBranding(r.data.data))
      .catch(() => setBranding(null))
      .finally(() => setLoading(false));
  }, [tenantId]);

  const b = branding || {};
  const API_BASE = process.env.REACT_APP_API_URL?.replace('/api', '') || '';
  const API_UPLOAD_BASE = process.env.REACT_APP_API_UPLOAD_URL;

  return {
    loading,
    businessName: b.businessName || 'Percept Pulse',
    tagline: b.tagline || '',
    logoUrl: b.logoUrl ? `${API_UPLOAD_BASE}${b.logoUrl}` : null,
    primaryColor: b.primaryColor || PRIMARY_COLOR,
    secondaryColor: b.secondaryColor || SECONDARY_COLOR,
    backgroundColor: b.backgroundColor || '#f8fafc',
    textColor: b.textColor || '#000',
    buttonTextColor: b.buttonTextColor || '#ffffff',
    gradient: `linear-gradient(135deg, ${b.primaryColor || PRIMARY_COLOR}, ${b.secondaryColor || SECONDARY_COLOR})`,
  };
};
